import React, { useContext } from "react";
import { HashLink } from "react-router-hash-link";
import {
  SearchResultPlan,
  PlanCategoryType,
  PlanDetailsSection,
} from "../../@types";
import {
  isPdPlanType,
  isMaPlanType,
  isMapdPlanType,
  useTranslate,
} from "../../helpers";
import { CheckmarkIcon, PlanDetailsHashLink } from "..";
import { AppContext } from "../../app/store";

interface DrugsProps {
  plan: SearchResultPlan;
  drugSelectionRoute: string;
  onGoToDrugSelection: () => void;
}

const Drugs: React.FunctionComponent<DrugsProps> = ({
  plan,
  drugSelectionRoute,
  onGoToDrugSelection,
}) => {
  const t = useTranslate();
  const {
    state: { prescriptions },
  } = useContext(AppContext);

  const planDetailsLink = (
    <PlanDetailsHashLink
      label={t("plan_terms.view_drugs_and_pharmacies")}
      plan={plan}
      section={PlanDetailsSection.OTHER_DRUG_INFO}
    />
  );

  let content;
  if (isMaPlanType(plan.plan_type)) {
    content = (
      <div>
        <CheckmarkIcon checked={false} />{" "}
        {t("plan_card.does_not_include_drugs")}
        {[
          PlanCategoryType.COST_1876,
          PlanCategoryType.PFFS,
          PlanCategoryType.MSA,
        ].includes(plan.category) && (
          <p className="ds-u-margin--0">
            {t("plan_card.pffs_cost.can_also_join")}
          </p>
        )}
      </div>
    );
  } else if (!prescriptions.length) {
    content = (
      <div>
        <HashLink to={drugSelectionRoute} onClick={onGoToDrugSelection}>
          {t("plan_card.add_your drugs")}
        </HashLink>
        <p className="ds-u-margin--0">{t("plan_card.add_your drugs_info")}</p>
      </div>
    );
  } else if (isPdPlanType(plan.plan_type)) {
    content = <div>{planDetailsLink}</div>;
  } else if (isMapdPlanType(plan.plan_type)) {
    content = (
      <div>
        <div>
          <CheckmarkIcon checked /> {t("plan_card.includes_drugs")}
        </div>
        <div>{planDetailsLink}</div>
      </div>
    );
  }

  return (
    <div className="PlanCard__section" data-testid="drugs">
      <h3 className="PlanCard__section_heading">
        {t("plan_card.section_heading.drugs")}
      </h3>
      {content}
    </div>
  );
};

export default Drugs;
